export default __webpack_public_path__ + "static/binance@2x-7f25a81f9a7fb632f7bdf5207410f923.png";